import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

export const withRouter = (Component) => {
  const ComponentWithRouterProp = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    // Create match object for backward compatibility with React Router v5
    const match = {
      params: params,
      isExact: true,
      path: location.pathname,
      url: location.pathname
    };

    return (
      <Component
        {...props}
        navigate={navigate}
        location={location}
        params={params}
        match={match}
      />
    );
  }

  return ComponentWithRouterProp;
}